import { ColorV2 } from "config/colors";
import { toRgba } from "config/colors.rgba.logic";

export const REMOVE_BUTTON_STYLES = {
  textColor: ColorV2.NegativeRed,
  borderColor: ColorV2.NegativeRed,
  iconColor: ColorV2.NegativeRed,
  hoverBackgroundColor: toRgba(ColorV2.NegativeRed, 0.08),
  activeBackgroundColor: toRgba(ColorV2.NegativeRed, 0.16),
};

export const tipAmountInputSelector = '[data-tip-amount-input="true"]';
